import {
    useParams
  } from "react-router-dom";
  import {useState, useEffect} from 'react';
  import axios from "axios"
  import {ProgressBar  } from "react-bootstrap"

  function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
 }


function Download() {
    let { fileid } = useParams();
    const [file, setFile] = useState({'name': 'abc.png', size: 65500})
    const [progress, setProgress] = useState();

    useEffect(()=> {
        axios.get(`/f/${fileid}`).then(function (response) {
            setFile(response.data);
          })
          .catch(function (error) {
            console.log(error);
          })
    }, [fileid])

    const beginDownload = () => {
        // axios.post(`https://share.erdenetmc.mn/f/${fileid}`).then(function (response) {
                
        //       })
        //       .catch(function (error) {
                
        //       })


              axios({
                url: `/f/${fileid}/download`,
                method: 'GET',
                responseType: 'blob',
                onDownloadProgress: (progressEvent) => {
                    //let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total); // you can use this to show user percentage of file downloaded
                    setProgress(Math.round((100 * progressEvent.loaded) / progressEvent.total))
                }
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.filename);
                document.body.appendChild(link);
                link.click();
            }).catch(error=>{
                //console.log(error.request);
                // for (let x in error)
                // console.log(x, error[x]);
                //alert(error.toJSON().stack);
                if (error.response) {
                    alert('Response')
                    alert(error.response.data);
                    alert(error.response.status);
                    alert(error.response.headers);
                  } else if (error.request) {
                    // The request was made but no response was received
                    alert('Request')
                    alert(error.request);
                  } else {
                    // Something happened in setting up the request that triggered an Error
                    alert('Custom')
                    alert(error.message);
                  }
                //alert(error.toJSON());
            });
     }
    
    return <div className="send">
                      
                    <div className="imgPanel">
                        <img src={require("./static/share-across.jpg")} width={"650px"} alt="sharing file" className="sendImage"/>
                    </div>
                    <div className="filePicker">
                        <div className="filePicker-content">
                            {file && <><div className='filedisplay'> 
                                <h5>Файл</h5>
                                <p style={{borderBottom:'1px solid grey',marginBottom:'20px'}}>{file.filename}</p>
                                
                                <p style={{fontSize:'12px'}}>Хэмжээ: {bytesToSize(file.size)}</p>
                                <p style={{fontSize:'12px'}}>Татагдсан тоо: {file.count}</p>
                                {progress && <ProgressBar id="statusIndicatorSend" now={progress} label={`${progress}%`} />}
                            </div><button id="upload" onClick={beginDownload}> Татах</button></>}
                        </div>
                    </div>

                    <div color="danger" id="alert">
                    </div>
                    
                </div>
}

export default Download;
